// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  font-size: 20px;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 2rem;
  margin-bottom: 3.5rem;
}
.page-header h1 {
  margin: 0;
}
.page-header .back-arrow {
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: #04abbd;
  text-decoration: none;
  font-size: 18px;
  border-radius: 4px;
  transition: background 0.2s, color 0.2s;
}
.page-header .back-arrow:hover {
  background: rgba(4, 171, 189, 0.1);
  color: #03929e;
  text-decoration: none;
}
.page-header .back-arrow i {
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/argic/view/technicalcommittee/technicalcommittee.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AACJ;AACI;EACI,SAAA;AACR;AAEI;EACI,kBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,uCAAA;AAAR;AAEQ;EACI,kCAAA;EACA,cAAA;EACA,qBAAA;AAAZ;AAGQ;EACI,eAAA;AADZ","sourcesContent":["h2{\r\n    font-size:20px;\r\n}\r\n\r\n.page-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n    padding-top: 2rem;\r\n    margin-bottom: 3.5rem;\r\n\r\n    h1 {\r\n        margin: 0;\r\n    }\r\n\r\n    .back-arrow {\r\n        position: absolute;\r\n        left: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        width: 40px;\r\n        height: 40px;\r\n        color: #04abbd;\r\n        text-decoration: none;\r\n        font-size: 18px;\r\n        border-radius: 4px;\r\n        transition: background 0.2s, color 0.2s;\r\n\r\n        &:hover {\r\n            background: rgba(4, 171, 189, 0.1);\r\n            color: #03929e;\r\n            text-decoration: none;\r\n        }\r\n\r\n        i {\r\n            font-size: 18px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
